import { createSlice } from "@reduxjs/toolkit";
import { getPurchaseOrder } from "../../reduxApi/admin/PurchaseOrderReduxApi";
import { addPurchaseOder } from "../../api/admin/PurchaseOrderApi";
import { getBlogCategoryApi } from "../../reduxApi/admin/BlogCategoryReducApi";
import { getBlogCategoryCountApi } from "../../reduxApi/admin/BlogCategoryReducApi";
const BlogCategorySlice = createSlice({
  name: "PurchaseOders",
  initialState: {
    status: "idle",
    getBlogCategory: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBlogCategoryApi.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getBlogCategoryApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.getBlogCategory = action.payload.data;
        console.log("state.getBlogCategory", state.getBlogCategory);
      })
      .addCase(getBlogCategoryCountApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.getBlogCategoryCount = action.payload.data;
      });
      
  },
});

export default BlogCategorySlice.reducer;
